import React from "react"

import CCMAdminFollowUpPatient from "./CCMAdminFollowUpPatient"

const CCMFollowUpView = () => <CCMAdminFollowUpPatient isFromAddPatient />

export default CCMFollowUpView
